import MuiTextField from '@mui/material/TextField'
import { styled } from '@mui/system'

const shouldForwardProp = (prop) => !['filled'].includes(prop)

const TextField = styled(MuiTextField, { shouldForwardProp })`
	.MuiInputAdornment-root {
		color: ${({ filled, theme }) => (filled ? theme.palette.primary.main : theme.palette.grey.medium)};
		.MuiIconButton-root {
			color: ${({ filled, theme }) => (filled ? theme.palette.primary.main : theme.palette.grey.medium)};
		}
	}
	.Mui-error {
		.MuiInputAdornment-root {
			color: ${({ filled, theme }) => (filled ? theme.palette.grey.main : theme.palette.grey.medium)};
		}
	}
	& .MuiInputLabel-root.Mui-focused {
		color: ${({ theme }) => theme.palette.grey.main};
		&.Mui-error {
			color: ${({ theme }) => theme.palette.error.main};
		}
	}
`

export { TextField }
